<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.gamification_sets', 2),
                        href: meta.links.set_index,
                    },
                    {
                        name: $tc('messages.faction_sets', 2),
                        href: meta.links.index,
                    },
                    {
                        name: factionSet.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <NavLinks :links="meta.navLinks.trimester" />
        </div>

        <div class="mt-5">
            <div class="w-full flex justify-between items-center">
                <div class="font-semibold text-lg">{{ factionSet.name }}</div>
            </div>
            <div class="mt-1 text-gray-500">
                {{ factionSet.getGamificationSetNames }}
            </div>
            <ul
                role="list"
                class="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8 mt-5"
            >
                <li class="relative" v-for="faction in factionSet.factions" :key="faction.id">
                    <div
                        class="group aspect-w-10 aspect-h-7 block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100"
                    >
                        <img
                            :src="faction.image_path"
                            alt=""
                            class="pointer-events-none object-contain group-hover:opacity-75"
                        />
                    </div>
                    <div class="flex justify-between mt-1">
                        <p class="pointer-events-none mt-2 block truncate text-sm font-medium text-gray-900">
                            {{ faction.name }}
                        </p>
                    </div>
                    <div>
                        {{ faction.experience_points_total }}
                    </div>
                </li>
            </ul>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import NavLinks from '../../../../components/NavLinks.vue';

export default {
    components: {
        NavLinks,
        PanelPage,
    },
    layout: Layout,
    name: 'Show',
    props: ['teacher', 'meta', 'options', 'factionSet'],
    data() {
        return {
            form: this.$inertia.form({
                name: this.factionSet.name,
                gamification_set_ids: this.factionSet.gamification_set_ids,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
